import React from "react";
import { ArrowForwardIos, ShoppingCartOutlined } from "@material-ui/icons";
import { Action } from "./styles";
import { useTranslation } from "react-i18next";
import { Item } from "../Item";
import { ProductList } from "../Products/styles";
import { ProductItem } from "../ProductItem";
import RegisterSoldProduct from "./RegisterSoldProduct";
import { API } from "../../../../../shared/services";
import { toast } from "react-toastify";
import { useContacts } from "../../../contexts";

function SoldProducts({ customer }) {
  const { setSpotlight } = useContacts();
  const { sold_products } = customer;
  const { updateCurrentContact } = useContacts();
  const { t } = useTranslation();

  function removeSoldProduct(soldProduct) {
    if (window.confirm("Você realmente deseja remover?")) {
      API.delete(`customers/${customer.id}/sold_products/${soldProduct.id}`)
        .then(() => {
          updateCurrentContact({
            ...customer,
            sold_products: customer.sold_products.filter(
              (sold) => sold.id !== soldProduct.id
            ),
          });

          toast.success("Produto marcado como fechado foi removido");
        })
        .catch(() => toast.error("Erro ao remover negócio fechado"));
    }
  }

  return (
    <Item
      leftAction={<ShoppingCartOutlined />}
      title={`${t("Customer:details.negotiationDone.title")}`}
    >
      <ProductList>
        {sold_products.length > 0 ? (
          sold_products.map((product) => (
            <ProductItem
              product={product}
              key={product.id}
              handleRemove={removeSoldProduct}
            />
          ))
        ) : (
          <p>Nenhum produto marcado como negócio fechado </p>
        )}
      </ProductList>

      <Action
        onClick={() =>
          setSpotlight(<RegisterSoldProduct customer={customer} />)
        }
      >
        <strong> Registrar novo negócio fechado</strong>
        <ArrowForwardIos />
      </Action>
    </Item>
  );
}

export default SoldProducts;
